import axiosClient from './axiosClient';

export const tagsApi = {
  list: async (params = {}) => {
    const { data } = await axiosClient.get('/tags', { params });
    return data.data;
  },

  get: async (id) => {
    const { data } = await axiosClient.get(`/tags/${id}`);
    return data.data;
  },

  create: async (payload) => {
    const { data } = await axiosClient.post('/admin/tags', payload);
    return data.data;
  },

  update: async (id, payload) => {
    const { data } = await axiosClient.put(`/admin/tags/${id}`, payload);
    return data.data;
  },

  destroy: async (id) => {
    const { data } = await axiosClient.delete(`/admin/tags/${id}`);
    return data.data;
  },
};